var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgWarningIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_22029",
    "data-name": "Group 22029",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 97.813,
    height: 87.358,
    viewBox: "0 0 97.813 87.358",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1847",
    "data-name": "Rectangle 1847",
    width: 97.813,
    height: 87.358,
    fill: "none"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_22028",
    "data-name": "Group 22028",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_558",
    "data-name": "Path 558",
    d: "M0,45.564A2.028,2.028,0,0,1,1.915,44.6c4.775.032,9.552.015,14.327.016a3.279,3.279,0,0,1,.667.025,1.366,1.366,0,0,1,1.194,1.4,1.347,1.347,0,0,1-1.1,1.38,3.475,3.475,0,0,1-.854.054c-4.712,0-9.424-.015-14.136.017A2.089,2.089,0,0,1,0,46.517Z",
    transform: "translate(0 -9.32)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_559",
    "data-name": "Path 559",
    d: "M118.868,46.517a2.1,2.1,0,0,1-2.008.968c-4.7-.032-9.4-.015-14.1-.015-.19,0-.382.009-.571-.008a1.459,1.459,0,0,1-1.433-1.474,1.421,1.421,0,0,1,1.437-1.366c.983-.036,1.969-.011,2.954-.011,3.907,0,7.814.021,11.72-.016a2.062,2.062,0,0,1,2.005.969Z",
    transform: "translate(-21.055 -9.32)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_560",
    "data-name": "Path 560",
    d: "M27.022,67.869H76.377V50.5c0-.254-.008-.509,0-.763.045-1.035.6-1.667,1.454-1.66s1.4.638,1.4,1.686q.014,8.436.006,16.874v1.277h1.743c2.812,0,2.932.122,2.932,2.972v5.929c1.476,0,2.867-.006,4.258,0,1.481.008,1.908.445,1.91,1.947q0,3.861,0,7.722c0,1.312-.484,1.815-1.758,1.815q-30.372,0-60.743,0a2.859,2.859,0,0,1-.571-.022,1.35,1.35,0,0,1-1.2-1.385,1.331,1.331,0,0,1,1.166-1.411,5.724,5.724,0,0,1,1.143-.04h59.05V79.734H16.186v5.712h4.885c.319,0,.638-.017.955.009a1.408,1.408,0,0,1,1.4,1.4,1.368,1.368,0,0,1-1.44,1.443q-3.63.039-7.258,0a1.347,1.347,0,0,1-1.445-1.44q-.036-4.289,0-8.58a1.36,1.36,0,0,1,1.531-1.445c1.49-.026,2.981-.007,4.625-.007V75.163c0-1.811-.012-3.623,0-5.434.012-1.288.524-1.795,1.8-1.811.918-.012,1.835,0,2.875,0v-1.29c.006-11.758-.126-23.518.052-35.273A27.549,27.549,0,0,1,78.944,28a31.714,31.714,0,0,1,.283,4.369c.037,4.1.019,8.2.008,12.3,0,1.038-.569,1.675-1.415,1.674s-1.4-.637-1.44-1.675c-.01-.254,0-.509,0-.763,0-3.877.048-7.754-.01-11.63-.146-9.6-4.37-16.941-12.68-21.7C49.133,2.236,30.293,11.134,27.409,27.6A26.859,26.859,0,0,0,27,32.143c-.033,11.631-.019,23.261-.017,34.893,0,.25.023.5.039.833m-4.668,8.877H80.973v-5.9H22.354Z",
    transform: "translate(-2.772 -0.956)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_561",
    "data-name": "Path 561",
    d: "M64.474,20.865H55.2c.186,1.777.358,3.473.543,5.168.206,1.894.434,3.785.63,5.68a1.475,1.475,0,0,1-1.322,1.762c-.807.059-1.41-.505-1.521-1.483-.379-3.312-.771-6.623-1.1-9.94-.278-2.78.969-4.109,3.762-4.115,2.515-.006,5.029-.013,7.544,0,2.5.016,3.811,1.376,3.562,3.849-.562,5.56-1.2,11.112-1.8,16.668-.283,2.587-.591,5.173-.846,7.765a4.792,4.792,0,0,1-9.579-.013c-.308-3.1-.667-6.187-1-9.281-.116-1.077.289-1.752,1.125-1.889.895-.147,1.558.39,1.689,1.49.373,3.153.707,6.31,1.054,9.466.142,1.3.858,2.034,1.967,2.01,1.064-.023,1.741-.75,1.879-2Q63.09,34.071,64.4,22.14c.041-.374.044-.752.072-1.276",
    transform: "translate(-10.948 -3.747)",
    fill: "#f8981c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_562",
    "data-name": "Path 562",
    d: "M60.517,62.662a4.83,4.83,0,1,1-4.8,4.877,4.785,4.785,0,0,1,4.8-4.877M60.5,65.526a1.914,1.914,0,0,0-1.91,1.955,1.959,1.959,0,1,0,3.917,0A1.919,1.919,0,0,0,60.5,65.526",
    transform: "translate(-11.644 -13.095)",
    fill: "#f8981c"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_563",
    "data-name": "Path 563",
    d: "M25.816,11.943a1.48,1.48,0,0,1-2.165,1.464,2.982,2.982,0,0,1-.581-.486Q17.97,7.836,12.877,2.744a2.89,2.89,0,0,1-.494-.577A1.326,1.326,0,0,1,12.609.428,1.313,1.313,0,0,1,14.354.251a3.946,3.946,0,0,1,.64.568q5,4.983,9.986,9.979a7.872,7.872,0,0,1,.836,1.145",
    transform: "translate(-2.541 0)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_564",
    "data-name": "Path 564",
    d: "M95.977,13.667c-1.4-.009-2.076-1.161-1.528-2.106a2.559,2.559,0,0,1,.426-.509Q100.035,5.892,105.2.739c.157-.156.331-.411.5-.416a3.455,3.455,0,0,1,1.66.146,1.194,1.194,0,0,1,.344,1.689,3.07,3.07,0,0,1-.606.728q-5.024,5.026-10.065,10.034a6.4,6.4,0,0,1-1.059.748",
    transform: "translate(-19.698 -0.062)",
    fill: "#434db8"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1846",
    "data-name": "Rectangle 1846",
    width: 58.619,
    height: 5.904,
    transform: "translate(19.582 69.885)",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_565",
    "data-name": "Path 565",
    d: "M61.261,66.283a1.919,1.919,0,0,1,2.007,1.955,1.959,1.959,0,1,1-3.917,0,1.914,1.914,0,0,1,1.91-1.955",
    transform: "translate(-12.403 -13.852)",
    fill: "#fff"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWarningIcon);
export default __webpack_public_path__ + "static/media/warning-icon.135dcb5b52cad76ec1129e3c62cd418e.svg";
export { ForwardRef as ReactComponent };